// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   PERFORMANCE OPTIMIZATIONS
   ============================================ */

/* Image optimization for all images */
img {
    max-width: 100%;
    height: auto;
    display: block;
    /* Enable GPU acceleration for smoother rendering */
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

/* Optimize animations and transitions */
* {
    /* Enable GPU acceleration for transforms and opacity */
    will-change: auto;
}

/* Specific will-change for interactive elements */
.primary-btn,
.ghost-btn,
.product-card,
.testimonial-item,
.hero-block,
a:hover,
button:hover {
    will-change: transform, opacity, background;
}

/* Remove will-change after animation completes */
.primary-btn:not(:hover),
.ghost-btn:not(:hover),
.product-card:not(:hover),
a:not(:hover),
button:not(:hover) {
    will-change: auto;
}

/* Optimize scrolling performance */
.testimonial-marquee,
.carousel-track {
    -webkit-overflow-scrolling: touch;
    transform: translateZ(0);
}

/* Reduce animation complexity on mobile */
@media (max-width: 768px) {
    * {
        animation-duration: 0.5s !important;
        transition-duration: 0.2s !important;
    }

    /* Disable complex animations on mobile for better performance */
    .carousel-track {
        animation: none !important;
    }

    /* Simplify box shadows on mobile */
    .hero-block,
    .product-card,
    .testimonial-item {
        box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;
    }
}

/* Optimize font loading */
@media screen and (prefers-reduced-data: reduce) {

    /* Reduce gradient complexity for low data mode */
    body,
    html,
    .page,
    .fibe-home {
        background: #FFE082 !important;
        background-attachment: scroll !important;
    }
}

/* Improve perceived performance with skeleton loading */
.lazy-loading {
    background: linear-gradient(90deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0.1) 100%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* Mobile viewport optimization */
@media (max-width: 640px) {

    /* Reduce padding on mobile for more content visibility */
    .page>section,
    .page>div:not(.hero-block):not(.admin-dashboard-layout),
    .fibe-home>section,
    .fibe-home>.hero-block {
        padding-left: 4vw;
        padding-right: 4vw;
    }

    /* Optimize touch targets for mobile */
    .primary-btn,
    .ghost-btn,
    button,
    a {
        min-height: 44px;
        min-width: 44px;
    }

    /* Reduce font size slightly on mobile for better readability */
    html {
        font-size: 15px;
    }
}

/* Tablet optimization */
@media (min-width: 641px) and (max-width: 1024px) {

    .page>section,
    .page>div:not(.hero-block):not(.admin-dashboard-layout),
    .fibe-home>section,
    .fibe-home>.hero-block {
        padding-left: 4vw;
        padding-right: 4vw;
    }
}

/* Reduce motion for accessibility and performance */
@media (prefers-reduced-motion: reduce) {

    *,
    *::before,
    *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
    }
}

/* Print optimization */
@media print {

    body,
    .page,
    .fibe-home {
        background: white !important;
    }

    .primary-btn,
    .ghost-btn {
        border: 1px solid #000 !important;
    }
}

/* Content visibility optimization for better performance */
.testimonial-item,
.product-card,
.offering-card {
    content-visibility: auto;
    contain-intrinsic-size: 0 300px;
}`, "",{"version":3,"sources":["webpack://./src/performance-optimizations.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,sCAAsC;AACtC;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mDAAmD;IACnD,wBAAwB;IACxB,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA,wCAAwC;AACxC;IACI,uDAAuD;IACvD,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;;;;;;;IAOI,2CAA2C;AAC/C;;AAEA,iDAAiD;AACjD;;;;;IAKI,iBAAiB;AACrB;;AAEA,mCAAmC;AACnC;;IAEI,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA,0CAA0C;AAC1C;IACI;QACI,mCAAmC;QACnC,oCAAoC;IACxC;;IAEA,gEAAgE;IAChE;QACI,0BAA0B;IAC9B;;IAEA,mCAAmC;IACnC;;;QAGI,yDAAyD;IAC7D;AACJ;;AAEA,0BAA0B;AAC1B;;IAEI,iDAAiD;IACjD;;;;QAII,8BAA8B;QAC9B,wCAAwC;IAC5C;AACJ;;AAEA,wDAAwD;AACxD;IACI;;;0CAGsC;IACtC,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,iCAAiC;AACjC;;IAEI,yDAAyD;IACzD;;;;QAII,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA,sCAAsC;IACtC;;;;QAII,gBAAgB;QAChB,eAAe;IACnB;;IAEA,+DAA+D;IAC/D;QACI,eAAe;IACnB;AACJ;;AAEA,wBAAwB;AACxB;;IAEI;;;;QAII,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,oDAAoD;AACpD;;IAEI;;;QAGI,qCAAqC;QACrC,uCAAuC;QACvC,sCAAsC;QACtC,gCAAgC;IACpC;AACJ;;AAEA,uBAAuB;AACvB;;IAEI;;;QAGI,4BAA4B;IAChC;;IAEA;;QAEI,iCAAiC;IACrC;AACJ;;AAEA,2DAA2D;AAC3D;;;IAGI,wBAAwB;IACxB,+BAA+B;AACnC","sourcesContent":["/* ============================================\n   PERFORMANCE OPTIMIZATIONS\n   ============================================ */\n\n/* Image optimization for all images */\nimg {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    /* Enable GPU acceleration for smoother rendering */\n    transform: translateZ(0);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n}\n\n/* Optimize animations and transitions */\n* {\n    /* Enable GPU acceleration for transforms and opacity */\n    will-change: auto;\n}\n\n/* Specific will-change for interactive elements */\n.primary-btn,\n.ghost-btn,\n.product-card,\n.testimonial-item,\n.hero-block,\na:hover,\nbutton:hover {\n    will-change: transform, opacity, background;\n}\n\n/* Remove will-change after animation completes */\n.primary-btn:not(:hover),\n.ghost-btn:not(:hover),\n.product-card:not(:hover),\na:not(:hover),\nbutton:not(:hover) {\n    will-change: auto;\n}\n\n/* Optimize scrolling performance */\n.testimonial-marquee,\n.carousel-track {\n    -webkit-overflow-scrolling: touch;\n    transform: translateZ(0);\n}\n\n/* Reduce animation complexity on mobile */\n@media (max-width: 768px) {\n    * {\n        animation-duration: 0.5s !important;\n        transition-duration: 0.2s !important;\n    }\n\n    /* Disable complex animations on mobile for better performance */\n    .carousel-track {\n        animation: none !important;\n    }\n\n    /* Simplify box shadows on mobile */\n    .hero-block,\n    .product-card,\n    .testimonial-item {\n        box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;\n    }\n}\n\n/* Optimize font loading */\n@media screen and (prefers-reduced-data: reduce) {\n\n    /* Reduce gradient complexity for low data mode */\n    body,\n    html,\n    .page,\n    .fibe-home {\n        background: #FFE082 !important;\n        background-attachment: scroll !important;\n    }\n}\n\n/* Improve perceived performance with skeleton loading */\n.lazy-loading {\n    background: linear-gradient(90deg,\n            rgba(255, 255, 255, 0.1) 0%,\n            rgba(255, 255, 255, 0.3) 50%,\n            rgba(255, 255, 255, 0.1) 100%);\n    background-size: 200% 100%;\n    animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: -200% 0;\n    }\n\n    100% {\n        background-position: 200% 0;\n    }\n}\n\n/* Mobile viewport optimization */\n@media (max-width: 640px) {\n\n    /* Reduce padding on mobile for more content visibility */\n    .page>section,\n    .page>div:not(.hero-block):not(.admin-dashboard-layout),\n    .fibe-home>section,\n    .fibe-home>.hero-block {\n        padding-left: 4vw;\n        padding-right: 4vw;\n    }\n\n    /* Optimize touch targets for mobile */\n    .primary-btn,\n    .ghost-btn,\n    button,\n    a {\n        min-height: 44px;\n        min-width: 44px;\n    }\n\n    /* Reduce font size slightly on mobile for better readability */\n    html {\n        font-size: 15px;\n    }\n}\n\n/* Tablet optimization */\n@media (min-width: 641px) and (max-width: 1024px) {\n\n    .page>section,\n    .page>div:not(.hero-block):not(.admin-dashboard-layout),\n    .fibe-home>section,\n    .fibe-home>.hero-block {\n        padding-left: 4vw;\n        padding-right: 4vw;\n    }\n}\n\n/* Reduce motion for accessibility and performance */\n@media (prefers-reduced-motion: reduce) {\n\n    *,\n    *::before,\n    *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n        scroll-behavior: auto !important;\n    }\n}\n\n/* Print optimization */\n@media print {\n\n    body,\n    .page,\n    .fibe-home {\n        background: white !important;\n    }\n\n    .primary-btn,\n    .ghost-btn {\n        border: 1px solid #000 !important;\n    }\n}\n\n/* Content visibility optimization for better performance */\n.testimonial-item,\n.product-card,\n.offering-card {\n    content-visibility: auto;\n    contain-intrinsic-size: 0 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
